/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'collapse': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<g _stroke="none" stroke-width="1" _fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"><polyline pid="0" _stroke="#03272E" points="20 14 16 18 12 14"/></g>'
  }
})



// WEBPACK FOOTER //
// ./src/assets/icons/collapse.js